// eslint-disable-next-line import/no-unresolved
import Cookies from 'js-cookie';

import { COUNTRY_CODE_CZ } from '@skippay/core/constants/countryCodes';
import { CURRENCY_CZK } from '@skippay/core/utils/amountUtils';
import { createHref } from '@skippay/core/utils/routeUtils';

import {
	COOKIE_KEY_PREFERRED_PROMO_SOURCE,
	COOKIE_KEY_PROMO_SOURCE,
	QUERY_PARAM_PROMO_SOURCE,
} from 'constants/queryAndStorageKeys';
import {
	ACCOUNT_UPGRADE,
	BNPL_LIMIT_MANAGEMENT,
	INSTALLMENTS,
	PAYMENT_CARD,
	PURCHASES,
	SEND_MONEY,
} from 'constants/routes';
import { getPaldockData } from 'utils/paldockUtils';

/**
 * @return {string | undefined}
 */
export const promoSourceFromCookie = () => Cookies.get(COOKIE_KEY_PROMO_SOURCE);
export const preferredPromoSourceFromCookie = () => Cookies.get(COOKIE_KEY_PREFERRED_PROMO_SOURCE);

const setCookieIfNotExists = (key, value, options) => {
	if (!Cookies.get(key)) {
		Cookies.set(key, value, options);
	}
};

export const storePromoSourceToCookie = (promoSource) =>
	setCookieIfNotExists(COOKIE_KEY_PROMO_SOURCE, promoSource, { expires: 30 });

export const storePreferredPromoSourceToCookie = (promoSource) =>
	Cookies.set(COOKIE_KEY_PREFERRED_PROMO_SOURCE, promoSource, { expires: 30 });

export const promoSourceFromQuery = (queryParams) => queryParams[QUERY_PARAM_PROMO_SOURCE];

export const promoSourceFromCookieOrQuery = (queryParams) => {
	const promoFromCookie = promoSourceFromCookie();
	const preferredPromoFromCookie = preferredPromoSourceFromCookie();

	if (queryParams && promoSourceFromQuery(queryParams)) {
		return promoSourceFromQuery(queryParams);
	}

	if (preferredPromoFromCookie) {
		return preferredPromoFromCookie;
	}

	return promoFromCookie;
};

export const getNextPathByPromoSource = (promoSource) => {
	switch (promoSource) {
		case 'pujcka':
		case 'splatky':
			return INSTALLMENTS;
		case 'pujcka-paldock': {
			const loanAmount = getPaldockData()?.loanAmount;
			return loanAmount
				? createHref({
						pathname: INSTALLMENTS,
						query: { maxInstallmentsPrincipal: loanAmount, currencyCode: CURRENCY_CZK },
					})
				: INSTALLMENTS;
		}
		case 'karta':
			return PAYMENT_CARD;
		case 'balicek-maxi':
			return ACCOUNT_UPGRADE;
		case 'pojisteni':
			return PURCHASES;
		case 'prevod-penez':
			return SEND_MONEY;
		case 'nastaveni-limitu':
			return BNPL_LIMIT_MANAGEMENT;
		default:
			return null;
	}
};

export const getNextPathByPromoSourceForCountry = (promoSource, country) =>
	country === COUNTRY_CODE_CZ ? getNextPathByPromoSource(promoSource) : null;
